import { trackEvent } from 'dibs-tracking';

export const locations = {
    SEARCH_BROWSE: 'SEARCH_BROWSE',
    SOLD_PDP: 'SOLD_PDP',
    UNLISTED_PDP: 'UNLISTED_PDP',
};

export const followSourceLabels = {
    [locations.SOLD_PDP]: 'sold pdp',
    [locations.UNLISTED_PDP]: 'unlisted pdp',
};

export const authLabels = {
    [locations.SEARCH_BROWSE]: 'save search - search/browse page',
    [locations.SOLD_PDP]: 'save search - sold pdp',
    [locations.UNLISTED_PDP]: 'save search - unlisted pdp',
};

export function trackFollowSearchAdded({ location }) {
    trackEvent({
        category: 'search favoriting',
        action: 'search added',
        label: followSourceLabels[location],
    });
}

export function trackFollowSearchRemoved({ location }) {
    trackEvent({
        category: 'search favoriting',
        action: 'search removed',
        label: followSourceLabels[location],
    });
}
